import React from "react";
import styled from "@emotion/styled";
import PageSectionWrapper from "../styles/PageSectionWrapper";
import TitleWrapper, { TitleWrapperPropTypes } from "../styles/TitleWrapper";
import PropTypes from "prop-types";
const EmptyWrapper = styled.div`
    display: flex;
    flex-direction: column;
`;
const ContentWrapper = styled.div`
    label: ContentWrapper;
`;

const PageSectionEmpty = ({ dataQa, title, children }) => (
    <PageSectionWrapper data-qa={`content-section-header-${dataQa}`}>
        <EmptyWrapper>
            {title && <TitleWrapper {...title} />}
            <ContentWrapper>{children}</ContentWrapper>
        </EmptyWrapper>
    </PageSectionWrapper>
);
export const PageSectionEmptyPropTypes = {
    title: PropTypes.shape(TitleWrapperPropTypes)
};
PageSectionEmpty.defaultProps = {};
PageSectionEmpty.propTypes = PageSectionEmptyPropTypes;
export default PageSectionEmpty;
